var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6784 1.49864L5.45218 9.76211C5.13693 10.079 4.6265 10.0786 4.31166 9.76129L0.215646 5.63719C0.0583263 5.47865 0.0583263 5.221 0.215646 5.06246L0.786516 4.48813C0.943836 4.32959 1.19945 4.32959 1.35698 4.48813L4.60717 7.76071C4.76449 7.91925 5.02011 7.91925 5.17763 7.76071L12.5381 0.349374C12.6954 0.190834 12.951 0.190834 13.1085 0.349374L13.679 0.923704C13.8367 1.08286 13.8363 1.3401 13.6784 1.49864ZM19.9258 0.923907L19.3637 0.349578C19.2086 0.191037 18.9567 0.191037 18.8016 0.349578L11.549 7.76071C11.3935 7.91925 11.1419 7.91925 10.9865 7.76071L10.405 7.16643C10.2499 7.00789 9.99838 7.00748 9.84289 7.16602L9.27996 7.73954C9.12447 7.89808 9.12406 8.15574 9.27955 8.31468L10.6954 9.76109C11.0054 10.0784 11.5087 10.0788 11.8191 9.7619L19.925 1.49844C20.0811 1.3401 20.0811 1.08245 19.9258 0.923907Z",
    fill: "#14AF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTickGreen);
export default __webpack_public_path__ + "static/media/double-tick_green.fb5d28ec19df7bf7e9b98784bf7bc713.svg";
export { ForwardRef as ReactComponent };